import React from "react";
import { ContentSection, GridRow, GridColumn, LabeledText, CodedProperty, ButtonRenderProps } from "sprint-common-web";

import { getLanguageDisplayName } from "../../../../../common/types/Language";
import {
    EditOnPremVideoAssetSubtitleAside,
    EditOnPremVideoAssetSubtitleAsideProps
} from "./edit/EditOnPremVideoSubtitleButtonAside";

interface OnPremSubtitleLanguageSectionProps {
    isLoading: boolean;
    language: CodedProperty;
}

export const OnPremSubtitleLanguagesSection = (props: OnPremSubtitleLanguageSectionProps): JSX.Element => {
    const { isLoading, language } = props;

    const editSubtitleButton: ButtonRenderProps<EditOnPremVideoAssetSubtitleAsideProps> = {
        isLabeled: true,
        render: EditOnPremVideoAssetSubtitleAside,
        subtitleId: language.id
    };

    return (
        <ContentSection header="Languages" isLoading={isLoading} buttons={[editSubtitleButton]}>
            <GridRow style={{ height: 200 }}>
                <GridColumn sm={12}>
                    <LabeledText label="Subtitles" value={getLanguageDisplayName(language)} />
                </GridColumn>
            </GridRow>
        </ContentSection>
    );
};
